import ErrorTitle from '@components/errorTitle';
import useAuth from '@hooks/useAuth';
import { t } from '@i18n';
import { Alert, Button, Container } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import { getErrorDetails, matchError } from '@util/errors';

export interface ErrorProps {
  error: unknown;
}

export default function Error({ error }: ErrorProps) {
  const { title = t('errors.title'), message } = matchError(error);
  const { user } = useAuth();
  const errorDetails = getErrorDetails(error, user);

  return (
    <Container my="md">
      <Alert color="red" icon={<IconExclamationCircle />} title={<ErrorTitle error={errorDetails}>{title}</ErrorTitle>}>
        <div
          css={{
            margin: '10px 0',
            maxHeight: '5em',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {message}
        </div>

        <Button onClick={() => window.location.reload()}>{t('common.reloadPage')}</Button>
      </Alert>
    </Container>
  );
}
